import { useEnrichMetadataMutation } from '@/hooks/api/use-enrich-metadata-mutation'
import { EnrichmentType } from '../constants'
import { useEnrichmentBase } from './use-enrichment-base'

export const useColumnEnrichment = (tableName: string, originalData?: any, schemaName?: string) => {
  const columnMutation = useEnrichMetadataMutation()

  const workflow = useEnrichmentBase({
    type: 'column' as EnrichmentType,
    identifier: schemaName ? `${schemaName}_${tableName}` : tableName,
    mutationFn: columnMutation.mutateAsync,
    originalData: tableName ? originalData : null,
    schemaName,
  })

  return workflow
}
